var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendtipsIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 48a48 48 0 1 1-96 0 48 48 0 0 1 96 0ZM36.2 15H42v9.4h5.7V15h5.6v9.4h.3c8 0 14.1 4.7 14.3 11.4.5 3.6-1.5 6.8-4.7 9 5.2 2.1 8.6 6.3 8 11.6 0 7.9-7.8 14.2-17.4 14.2h-.5V80h-5.6v-9.4h-5.7V80h-5.7v-9.4H24V63h7.5V31H24v-6.6h12.2V15ZM42 31v12.3h9a6.1 6.1 0 0 0 0-12.3h-9Zm0 32h10.9a7 7 0 0 0 0-14H41.8v14Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendtipsIconDark);
export default __webpack_public_path__ + "static/media/sendtips_icon_dark.8ab673cda0fe4cd23b60356fba7abf75.svg";
export { ForwardRef as ReactComponent };